/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The type of entity represented by this account.
 */
export const AccountType = {
  Individual: "individual",
  Business: "business",
  Guest: "guest",
} as const;
/**
 * The type of entity represented by this account.
 */
export type AccountType = ClosedEnum<typeof AccountType>;

/** @internal */
export const AccountType$inboundSchema: z.ZodNativeEnum<typeof AccountType> = z
  .nativeEnum(AccountType);
/** @internal */
export const AccountType$outboundSchema: z.ZodNativeEnum<typeof AccountType> =
  AccountType$inboundSchema;
